import styles from "../../pages/CodesList.module.css";
import React from "react";

interface ResetCodeModalProps {
  show: boolean;
  selectedCode: { code: string } | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const ResetCodeModal: React.FC<ResetCodeModalProps> = ({ show, selectedCode, onCancel, onConfirm }) => {
  if (!show || !selectedCode) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>
          האם אתה בטוח שברצונך להחזיר את המספר {selectedCode.code}?
        </h3>
        <p className={styles.modalDescription}>
          פרטי ההזמנה לקוד יימחקו והוא יחזור לזמינות
        </p>
        <div className={styles.modalActions}>
          <button onClick={onCancel} className={styles.cancelButton}>
            ביטול
          </button>
          <button onClick={onConfirm} className={styles.updateButton}>
            החזר
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetCodeModal;
